import React from "react"
import './SuspenseFallback.css'


export default function SuspenseFallback () {
	return <div className={'suspense-fallback'} />
}